import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import axios from 'axios';
import './Login.css';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();
  const { login } = useAuth(); // Get login function from context

  const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    const response = await axios.post('https://api.assetview.warrantyindia.com/api/auth/login', {
      username,
      password,
    });

    if (response.status === 200) {
      const userData = response.data.user; // full user object
      const userType = userData.user;      // plain string

      // Save session
      sessionStorage.setItem('user', userType);
      sessionStorage.setItem('user2', JSON.stringify(userData));

      login();
      setMessage('✅ Login successful! Redirecting...');

      // 👉 Important: READ username from API
      const loggedUsername = (userData.username || "").toLowerCase().trim();

      setTimeout(() => {
        if (loggedUsername === "vinod" || loggedUsername === "bhawesh" || loggedUsername === "krishna" ||loggedUsername==="admin") {
          // allowed: redirect to employee search
          navigate('/employeesearch');
        } else {
          // other users → redirect to add asset
          navigate('/addasset1');
        }
      }, 800);
    }
  } catch (err) {
    setMessage('❌ Incorrect username or password. Please try again.');
    console.error('Login error:', err);
  }
};



  return (
    <div className="login-container">
      <form className="login-form" onSubmit={handleSubmit}>
        <h2>Login</h2>

        {message && <p className="message">{message}</p>}

        <div className="input-group">
          <label htmlFor="username">Username</label>
          <input
            type="text"
            id="username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
            placeholder="Enter your username"
          />
        </div>

        <div className="input-group">
          <label htmlFor="password">Password</label>
          <input
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            placeholder="Enter your password"
          />
        </div>

        <button type="submit" className="login-btn">Login</button>
      </form>
    </div>
  );
};

export default Login;
